export const generateHtml = (draft, alignment = "center") => {
  if (!draft) return "";

  const { poll_type, template_data, poll_options, slug } = draft;
  const { customization, variant, uniqueUserCode, gifLableVisible } =
    template_data || {};
  const { answer, question, general } = customization || {};

  const generateLink = (optionId) => {
    return `${
      window.location.origin
    }/submit-poll/poll_slug=${slug}&amp;poll_option_id=${optionId}${
      uniqueUserCode ? "&amp;uid={UNIQUE IDENTIFIER}" : ""
    }`;
  };

  const generateOptionHtml = (option, index, isGif = false) => {
    const link = generateLink(option.id);
    const optionText = option.option_template_data.option_text;
    const optionEmoji = option.option_template_data.emoji;
    const optionGif = option.option_template_data.gif_url;

    const sizeMultiplier = parseFloat(general?.size) || 1;
    const baseFontSize = 14;
    const fontSize = `${baseFontSize * sizeMultiplier}px`;

    const baseHeight = 25;
    const baseWidth = 30;
    const height = `${baseHeight * sizeMultiplier}px`;
    const width = `${baseWidth * sizeMultiplier}px`;

    const basePadding = 10;
    const padding = `${basePadding * sizeMultiplier}px`;

    const baseMargin = 10;
    const margin = `${baseMargin * sizeMultiplier}px`;

    const baseBorderRadius = 8;
    const borderRadius = `${baseBorderRadius * sizeMultiplier}px`;

    return `
            <td style="margin-top : ${padding}; display: ${
      !isGif ? "block" : ""
    };" class="polls-html">
                <a href="${link}" target="_blank" style="display: ${
      gifLableVisible ? "block" : "flex"
    }; align-items: center; text-decoration: none; border: 1px solid #${
      answer?.border
    }; border-radius: ${borderRadius}; padding: ${padding} ; font-size: ${fontSize}; color: #${
      answer?.text
    }; font-family: ${answer?.font} !important; background-color: #${
      answer?.questionBackground
    };">
                    ${
                      !isGif
                        ? `
                                <span style="background: #4E84A1; color: #fff; border-radius: ${borderRadius}; height: ${height}; width: ${width}; display: inline-block; text-align: center; line-height: ${height}; margin-right: ${margin};">
                                    ${String.fromCharCode(65 + index)}
                                </span>
                                ${optionText}
                            `
                        : `
                                <div style="display: inline-flex">
                                    <img src="${optionGif}" alt="gif" style="width:${
                            150 * sizeMultiplier
                          }px; height:${
                            96 * sizeMultiplier
                          }px; border-radius: ${borderRadius};"/>
                                </div>
                              ${
                                gifLableVisible
                                  ? `<span style="font-size: ${fontSize}; margin-top: ${margin}; font-family: ${
                                      answer?.font
                                    } !important; border: 1px solid #${
                                      answer?.border
                                    }; border-radius: ${borderRadius}; padding: ${padding}; width: auto; display:block;">
                                ${
                                  gifLableVisible
                                    ? `
                                              <span style="background: #4E84A1; color: #fff; border-radius: ${borderRadius}; height: ${height}; width: ${width}; display: inline-block; text-align: center; line-height: ${height}; margin-right: ${margin};">
                                    ${String.fromCharCode(65 + index)}
                                </span>
                                ${optionText}
                                        `
                                    : ""
                                }
                                </span>`
                                  : ""
                              }
                            `
                    }
                </a>
            </td>
            
           
            `;
  };

  const generateYesNoHtml = (option, index) => {
    const link = generateLink(option.id);
    const sizeMultiplier = parseFloat(general?.size) || 1;
    const baseFontSize = 14;
    const fontSize = `${baseFontSize * sizeMultiplier}px`;

    const basePadding = 20;
    const padding = `${basePadding * sizeMultiplier}px`;

    const baseGap = 30;
    const gap = `${baseGap * sizeMultiplier}px`;

    const baseBorderRadius = 11;
    const borderRadius = `${baseBorderRadius * sizeMultiplier}px`;

    return `
        <td style="width: 100%;">
            <a target="_blank" href="${link}" style="width: 100%; display: block; gap: ${gap}; font-size: ${fontSize}; outline: none; border: none; font-weight: 500; ${
      index === 0 ? `border-right: 1px solid #${answer?.border};` : ""
    } text-decoration: none; color: #${answer?.text}; font-family: ${
      answer?.font
    } !important; background-color: #${
      answer?.questionBackground
    }; margin: 0 auto; text-align: center; cursor: pointer;">
                ${
                  variant === "emoji"
                    ? option.option_template_data.emoji
                    : option.option_template_data.option_text
                }
            </a>
        </td>
    `;
  };

  const generateRatingHtml = (option, index) => {
    const link = generateLink(option.id);
    const sizeMultiplier = parseFloat(general?.size) || 1;
    const baseFontSize = 14;
    const fontSize = !template_data.translateToEmojis
      ? `${baseFontSize * sizeMultiplier}px`
      : `${(12 + index * 2) * sizeMultiplier}px`;

    const baseHeight = 48;
    const baseWidth = 56;
    const height = `100%`;
    const width = `100%`;

    const basePadding = 10; // 0px base padding
    const padding = `${basePadding * sizeMultiplier}px`;

    return `
        <td align="center" valign="middle" style="padding: ${padding}; display: block; height: ${height}; width: ${width}; outline: none; border: 1px solid #${
      answer?.border
    }; text-align: center; background-color: #${answer?.questionBackground}">
            <a target="_blank" href="${link}" style="display: inline-block; font-size: ${fontSize}; vertical-align: middle; font-family: ${
      answer?.font
    } !important; color: #${
      answer?.text
    }; text-decoration: none; text-align: center; line-height: ${height}; width: 100%; height: 100%; background-color: transparent;">
                ${
                  template_data.translateToEmojis
                    ? option.option_template_data.emoji
                    : option.option_template_data.option_text
                }
            </a>
        </td>
    `;
  };

  let baseHtml = "";

  if (poll_type === "multiple-choice") {
    baseHtml = `
      <tbody style="display:block; width:100%;">
      <tr style="display:${
        variant === "gif" ? "flex" : "block"
      }; flex-wrap: wrap;justify-content: space-between;">
        ${poll_options
          ?.filter((option) => !option.archived)
          .map((option, index) =>
            generateOptionHtml(option, index, variant === "gif")
          )
          .join("")}  
      </tr>
      </tbody>
  `;
  } else if (poll_type === "yes-no") {
    const baseWidth = 216;
    const baseHeight = 35;
    const sizeMultiplier = parseFloat(general?.size) || 1;
    const width = `${baseWidth * sizeMultiplier}px`;
    const height = `${baseHeight * sizeMultiplier}px`;
    baseHtml = `
      <tbody style="width: ${width}; display: block; margin: 0 auto;">
        <tr class="polls-html" style="display: flex; border-radius: ${11}px; width: ${width}; height: ${height}; border: 1px solid #${
      answer?.border
    }; overflow: hidden; align-items: center;">
          ${poll_options
            ?.filter((option) => !option.archived)
            .map((option, index) => generateYesNoHtml(option, index))
            .join("")}
        </tr>
      </tbody>
  `;
  } else if (poll_type === "rating") {
    baseHtml = `
      <tbody style="width: 100%; display: block;">
        <tr class="polls-html" style="display: flex; justify-content: space-between; align-items: center; border: 1px solid #${
          answer?.border
        }; width: 100%;">
          ${poll_options
            ?.filter((option) => !option.archived)
            .map((option, index) => generateRatingHtml(option, index))
            .join("")}
        </tr>
      </tbody>
  `;
  }

  const sizeMultiplier = parseFloat(general?.size) || 1;
  const headingFontSize = `${20 * sizeMultiplier}px`;
  const baseTablePadding = 20;
  const tablePadding = `${baseTablePadding * sizeMultiplier}px`;

  return `
      <div class="polls-html">
          <table align="${alignment}" style="display: block; background-color: #${
    general?.bodyBackgroundColor || "#ffffff"
  }; border: 1px solid #f8fafc; border-radius: ${
    8 * sizeMultiplier
  }px; padding: ${tablePadding}; max-width: ${
    400 * sizeMultiplier
  }px; text-align: left;width:100%;">
              <thead style="font-size: ${headingFontSize} !important; font-weight: 600; margin: 0 0 ${
    1 * sizeMultiplier
  }rem; color: #${question?.text || "#2b2524"}; font-family: ${
    question?.font || "inherit"
  }; background-color: #${
    question?.questionBackground || "transparent"
  }; width: 100%; display: block; border-radius: ${8 * sizeMultiplier}px;">
                  <tr>
                      <th style="padding: ${
                        15 * sizeMultiplier
                      }px; text-align: left; border-radius: ${
    8 * sizeMultiplier
  }px;">
                          ${template_data?.question || "Poll Question"}
                      </th>
                  </tr>
              </thead>
              ${baseHtml}
          </table>
      </div>
  `;
};
